if (!customElements.get('description-toggle')) {
  customElements.define(
    'description-toggle',
    class DescriptionToggle extends HTMLElement {
      connectedCallback() {
        if (this.swervInit) return;

        this.button = this.querySelector('.product__description-toggle-button');
        this.content = this.querySelector('.product__description');
        if (!this.button || !this.content) return;

        this.swervInit = true;

        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          const expanded = this.classList.toggle('is-expanded');
          this.button.setAttribute('aria-expanded', expanded);
          this.button.textContent = expanded ? 'Read less' : 'Read more';
        });

        // Measure after layout has settled. Measuring synchronously can report
        // a collapsed (zero height) element if stylesheets or late app scripts
        // have not finished, which used to hide the toggle entirely.
        this.refresh();
        requestAnimationFrame(() => this.refresh());
        window.addEventListener('load', () => this.refresh());

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.refresh());
          this.resizeObserver.observe(this.content);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      refresh() {
        if (!this.button || !this.content) return;

        // Once expanded the button becomes "Read less" and must stay visible.
        if (this.classList.contains('is-expanded')) {
          this.button.style.display = '';
          return;
        }

        const clipped = this.content.scrollHeight > this.content.clientHeight + 1;

        // Use inline display rather than the `hidden` attribute: the stylesheet
        // sets `display: block` on this button, which overrides `[hidden]`.
        this.button.style.display = clipped ? '' : 'none';
      }
    }
  );
}
